import { Injectable } from "@angular/core";
import { HttpClient } from "@angular/common/http";

@Injectable()
export class TranslateService {
  data: any = {};
  currentLang: string;

  constructor(private http: HttpClient) {}

  use(lang: string): Promise<{}> {
    return new Promise<{}>((resolve, reject) => {
      const langPath = `assets/i18n/${lang || "en"}.json`;

      this.http.get<{}>(langPath).subscribe(
        translation => {
          this.currentLang = lang;
          this.data = Object.assign({}, translation || {});
          resolve(this.data);
        },
        error => {
          this.data = {};
          resolve(this.data);
        }
      );
    });
  }
  getcurrentLang(){
    return this.currentLang;
  }
}
